import moment from "moment";
import { formatMoneyAddDecimalPoint } from "../../../util/PaymentUtils";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const costBreakdownItems = (costData: Record<string, any> | null | undefined, startDate: string) => {
    const firstCycleDates = `${moment(startDate).format('MM/DD/YYYY')} - ${costData?.firstRecurringPaymentDate ? moment(costData?.firstRecurringPaymentDate).subtract(1, 'day').format('MM/DD/YYYY') : 'Pending'}`;
    const days = costData?.duration;
    const nextMonthlyPaymentDate = costData?.firstRecurringPaymentDate;

    const initialGross = `$${formatMoneyAddDecimalPoint(costData?.initialCharge)}`;
    const initialNet = `$${formatMoneyAddDecimalPoint(costData?.initialTotalCharge)}`;
    const recurringPayment = `$${formatMoneyAddDecimalPoint(costData?.recurringCharge)}`;
    const initialProcessingFee = `$${formatMoneyAddDecimalPoint(costData?.initialProcessingFee)}`;
    const recurringProcessingFee = `$${formatMoneyAddDecimalPoint(costData?.recurringProcessingFee)}`;
    const initialTaxes = `$${formatMoneyAddDecimalPoint(costData?.initialBookingTaxAmount)}`;
    const recurringTaxes = `$${formatMoneyAddDecimalPoint(costData?.recurringBookingTaxAmount)}`;
    const recurringNet = `$${formatMoneyAddDecimalPoint(costData?.recurringTotalCharge)}`;

    const firstCycleItems = [{
        label: 'First Cycle Dates Covered:',
        value: firstCycleDates,
        formattedValue: firstCycleDates
    },
    {
        label: 'First Cycle Booking Charge:',
        value: initialGross
    }];

    const monthlyItems = [
        {
            label: "Processing Fee:",
            value: initialProcessingFee
        },
        {
            label: "Taxes:",
            value: initialTaxes
        }];
        
    const brokeredMonthlySummary = [{
            label: 'Payment Day of the Month:',
            value: '1st'
        },{
            label: "Next Payment Date:",
            value: nextMonthlyPaymentDate,
            formttedValue: nextMonthlyPaymentDate
        },
        {
            label: 'Monthly Booking Charge:',
            value: recurringNet
        }];
        
    const monthlySummary = [{
            label: 'Payment Day of the Month:',
            value: '1st'
        },{
            label: "Next Payment Date:",
            value: nextMonthlyPaymentDate,
            formattedValue: nextMonthlyPaymentDate
        },
        {
            label: 'Monthly Booking Charge:',
            value: recurringPayment,
        },{
            label: "Processing Fee:",
            value: recurringProcessingFee
        },{
            label: "Taxes:",
            value: recurringTaxes
        },];
    
    const brokeredDailyItems = [{
            label: 'Days:',
            value: days,
            formattedValue: days
        },{
            label: "Subtotal:",
            value: initialGross
        }];
    
    const dailyItems = [{
            label: 'Days:',
            value: days,
            formattedValue: days
        },{
            label: "Subtotal:",
            value: initialGross
        },{
            label: "Processing Fee:",
            value: initialProcessingFee
        },{
            label: "Taxes:",
            value: initialTaxes
        }];
    
    const brokeredInitialTotal = {
        label: "Today's Estimated Total:",
        value: initialGross
    };

    const initialTotal = {
            label: "Today's Payment Total:",
            value: initialNet
    };

    const brokeredRecurringTotal = {
            label: "Total Estimated Monthly Payment:",
            value: recurringPayment
    };
    
    const recurringTotal = {
            label: "Total Monthly Payment:",
            value: recurringNet
    };

    const brokeredDailyTotal = {
        label: 'Total Estimated Payment:',
        value: initialGross
    };

    const dailyTotal = {
        label: "Total:",
        value: initialNet
    };

    return {firstCycleItems, brokeredDailyTotal, dailyTotal, brokeredInitialTotal, initialTotal, brokeredMonthlySummary, monthlySummary, brokeredDailyItems, monthlyItems, dailyItems, brokeredRecurringTotal, recurringTotal}
}

